import { getConfigsService } from "../../../services/userServices";

export const setAppConfigsAction = (config) => {
  return async (dispatch) => {
    if (config) {
      await dispatch({ type: "SET_APP_CONFIGS", payload: config });
    } else {
      try {
        const { status, data } = await getConfigsService();
        if (status === 200) {
          const items = data?.reduce((acc, item) => {
            acc[item.key] = item.value;
            return acc;
          }, {});
          await dispatch({
            type: "SET_APP_CONFIGS",
            payload: items,
          });
        }
      } catch ({ response }) {
        console.log("Karbama Configs");
      }
    }
  };
};

export const clearAppConfigsAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "CLEAR_APP_CONFIGS", payload: {} });
  };
};
